
const Accordion = (target) => {

  const transitionDuration = 0.5;

  const el = {
    heads: target.querySelectorAll(".accordion__head"),
  };

  const method = {

    init: () => {
      Array.prototype.forEach.call(el.heads, (head) => {
        head.addEventListener("click", method.toggleHead);
      });
    },

    closeItem: (accordionItem) => {
      const accordionBody = accordionItem.querySelector(".accordion__body");
      // get the height
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      accordionItem.classList.remove("accordion__item--selected");
      // set inline height
      accordionBody.style.height = `${accordionBodyHeight}px`;
      // zero the height (animate)
      setTimeout(() => {
        accordionBody.style.height = 0;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute("style"), transitionDuration * 1000);
      }, 10);
    },

    openItem: (accordionItem) => {
      accordionItem.classList.add("accordion__item--selected");
      // get the height (after opened)
      const accordionBody = accordionItem.querySelector(".accordion__body");
      const accordionBodyHeight = accordionBody.getBoundingClientRect().height;
      // immediately zero the height (don't open yet)
      accordionBody.style.height = 0;
      // set inline height to animate
      setTimeout(() => {
        accordionBody.style.height = `${accordionBodyHeight}px`;
        // remove inline height after the transition
        setTimeout(() => accordionBody.removeAttribute("style"), transitionDuration * 1000);
      }, 10);
    },

    toggleHead: (event) => {
      const accordionItem = event.currentTarget.parentElement;
      const accordionItemIsSelected = accordionItem.classList.contains("accordion__item--selected");
      const accordion = accordionItem.parentElement;

      if (!accordionItemIsSelected) {
        // if it's not a multi accordion stick to default behaviour (close other opened items)
        if (accordion.getAttribute("data-mode") !== "multi") {
          const selectedItem = accordion.querySelector(".accordion__item--selected");
          if (selectedItem) method.closeItem(selectedItem);
        }
        // open the item
        method.openItem(accordionItem);
      } else {
        // close current item (if it was opened)
        method.closeItem(accordionItem);
      }
    },
  };

  method.init();
};

export default Accordion;
